module.exports = __webpack_public_path__ + "static/media/editIcon.1b45f2c6.svg";